import Router from 'vue-router'
import { getAuthState } from './index'
/* const subPage = {
  template: '<router-view></router-view>'
} */

export default class extends Router {
  constructor (arg) {
    super(arg)
    this.map({
      '/login': {
        component: require('./components/pages/Login.vue'),
        noauth: true
        // noloading: true
      },
      '/': {
        name: 'index',
        component: require('./components/pages/Index.vue')
      },
      '/servicelog': {
        name: 'servicelog',
        component: require('./components/pages/ServiceLog.vue')
      },
      '/demo': {
        name: 'demo',
        component: require('./components/pages/Index.vue')
      }
    })
    this.beforeEach(({ to, next, abort }) => {
      if (to.matched === null) {
        console.log('state is null')
        abort()
        this.replace('/')
      } else if (to.noauth) {
        next()
      } else {
        getAuthState().then(state => {
          if (state) {
            return next()
          }
          abort()
          this.replace('/login')
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/Router.js